module.exports = __webpack_public_path__ + "img/app-icon-5.e27d983d.svg";